const openCloseToggle = (el) => {
	for( let child of el.parentNode.children ){
		child !== el && child.classList.remove('active')
		child !== el && jQuery(child.lastElementChild).slideUp()
	}
	if (el.classList.contains('active')) {
		el.classList.remove('active')
		jQuery(el.lastElementChild).slideUp()
	} else {
		el.classList.add('active')
		jQuery(el.lastElementChild).slideDown()
		if (document.querySelector('.agenturfinder')) {
			let navOffset = 0;
			if(window.innerWidth < 768) navOffset = 65
			setTimeout(() => {
				console.log(navOffset);
				window.scrollTo({top: el.getBoundingClientRect().top + window.scrollY - navOffset, left: 0, behavior: 'smooth'})				
			}, 350)
		}
		
	}
}

class GrowToggle {

	toggleHeaderElements = ""
	toggleElements = ""

	constructor() {
	}
	
	init() { 
		this.toggleHeaderElements = document.querySelector('.togglebox__header__item') ? document.querySelectorAll('.togglebox__header__item') : null
		this.toggleElements = document.querySelector('.togglebox__content__item') ? document.querySelectorAll('.togglebox__content__item') : null
	}

	toggle(el) { 
		if (el.classList.contains('active')) {
			el.classList.remove('active')
		} else {
			el.classList.add('active')
		}
	}

	scrollTo(el) {
		// scroll to element
		el.scrollIntoView({
			behavior: 'smooth',
			block: "start"
		})
	 }

	open(el, elementId) { 
		this.toggleHeaderElements.forEach((el) => {
			el.classList.remove('active')
		})
		this.toggleElements.forEach((el) => {
			el.classList.remove('active')
		})
		el.parentNode.classList.add('active')
		const targetElement = document.querySelector('[data-toggle="' + elementId + '"]')
		targetElement.classList.add('active')
		this.scrollTo(targetElement)
	}
}


const growToggle = new GrowToggle()		

document.addEventListener('DOMContentLoaded', () => { 
	growToggle.init()
})